import { Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import BreadCrumb from "../../components/Common/BreadCrumb";
import HubSpotIntegrationCard from "./components/HubSpotIntegrationCard";
import Every8DIntegrationCard from "./components/Every8DIntegrationCard";
import "./styles.css";

const Integration = () => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("integration.pageTitle") });

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={t("integration.pageTitle")}
          pageTitle={t("integration.breadcrumbParent")}
        />

        <Row className="g-4">
          <Col xl={6}>
            <HubSpotIntegrationCard />
          </Col>
          <Col xl={6}>
            <Every8DIntegrationCard />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Integration;
